function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "20200320_new copy 4");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "20200320_new-copy-4",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M59.3627018,20 C61.7221666,20 63.8625965,21.3828557 64.8324192,23.5337899 L85.6375813,69.6767991 C86.5456148,71.6906935 85.6491375,74.0593839 83.6352432,74.9674174 C83.4521273,75.0499816 83.2630523,75.1186351 83.0696228,75.1727953 L67.6504318,79.4901688 C64.7914387,80.2906869 61.7768721,78.8798798 60.5598835,76.1718159 L37.2173979,24.2297156 C36.5382448,22.7184523 37.2128033,20.9427688 38.7240667,20.2636156 C39.1107422,20.0898458 39.5298556,20 39.9537823,20 L59.3627018,20 Z M33.6846111,34.2079285 C34.2295663,34.4504986 34.6378043,34.9236553 34.797913,35.4982696 L44.2155495,69.297236 C44.5120292,70.3612725 43.8898015,71.4641887 42.8257651,71.7606685 L42.8111569,71.7646793 L42.8111569,71.7646793 L19.0600463,78.1891496 C16.9275432,78.7659733 14.7311998,77.5048459 14.1543762,75.3723428 C13.9142709,74.4846797 13.987341,73.5413949 14.3612843,72.7012981 L31.0441394,35.2217871 C31.4933162,34.2126717 32.6754957,33.7587517 33.6846111,34.2079285 Z",
  id: "Combined-Shape-Copy-3",
  fill: "currentColor"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/additor-symbol.3d3b5af0.svg";
export { SvgComponent as ReactComponent };